import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4PluginsForceDirected from '@amcharts/amcharts4/plugins/forceDirected';

interface Props {
    tracks: ProTrack[];
}

const chartDivId = 'earnings-per-track';

export class EarningsPerTrack extends Component<Props> {
    private chart: am4PluginsForceDirected.ForceDirectedTree | null = null;

    private networkSeries: am4PluginsForceDirected.ForceDirectedSeries | null =
        null;

    componentDidMount(): void {
        const { tracks } = this.props;

        const chart = am4core.create(
            chartDivId,
            am4PluginsForceDirected.ForceDirectedTree,
        );
        const networkSeries = chart.series.push(
            new am4PluginsForceDirected.ForceDirectedSeries(),
        );

        chart.numberFormatter.numberFormat = '#,###.00';

        networkSeries.data = tracks;
        networkSeries.dataFields.name = 'work_title';
        networkSeries.dataFields.value = 'earnings';
        networkSeries.links.template.distance = 1;
        // eslint-disable-next-line no-template-curly-in-string
        networkSeries.nodes.template.tooltipText = '{name}: ${value}';
        networkSeries.nodes.template.fillOpacity = 1;
        networkSeries.nodes.template.outerCircle.scale = 1;
        networkSeries.nodes.template.label.text = '{name}';
        networkSeries.fontSize = 12;
        networkSeries.nodes.template.label.hideOversized = true;
        networkSeries.nodes.template.label.truncate = true;
        networkSeries.manyBodyStrength = -5;
        networkSeries.links.template.strokeOpacity = 0;

        this.chart = chart;
        this.networkSeries = networkSeries;
        this.setRadii();
    }

    componentDidUpdate(prevProps: Props): void {
        const { tracks } = this.props;

        if (prevProps.tracks !== tracks && this.networkSeries !== null) {
            this.networkSeries.data = tracks;
            this.setRadii();
        }
    }

    componentWillUnmount(): void {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    setRadii(): void {
        if (this.networkSeries !== null) {
            const { length } = this.networkSeries.data;
            let minRadius;
            let maxRadius;

            if (length < 30) {
                minRadius = am4core.percent(5);
                maxRadius = am4core.percent(15);
            } else if (length < 50) {
                minRadius = am4core.percent(4);
                maxRadius = am4core.percent(13);
            } else if (length < 70) {
                minRadius = am4core.percent(3);
                maxRadius = am4core.percent(11);
            } else {
                minRadius = am4core.percent(2);
                maxRadius = am4core.percent(10);
            }

            this.networkSeries.minRadius = minRadius;
            this.networkSeries.maxRadius = maxRadius;
        }
    }

    render(): JSX.Element {
        return (
            <div id={chartDivId} style={{ width: '100%', height: '500px' }} />
        );
    }
}
